const actionSetI18n = "SET_I8N";

export { actionSetI18n };
